import React from 'react';
import PropTypes from 'prop-types';
import {
  utils,
} from '@resy/ui-kitchen';
import ResyCalendar from '../../../../../../ui-kitchen/src/components/ResyCalendar';
import Selector from '../../Nav/Selector';
import './AmexShopSmallSelector.scss';
import { ALL_DAY } from '../../../../../../ui-kitchen/src/constants/resyCore';

class AmexShopSmallSelector extends React.Component {
    static propTypes = {
      matchMedia: PropTypes.shape({
        xs: PropTypes.bool,
        sm: PropTypes.bool,
        md: PropTypes.bool,
        lg: PropTypes.bool,
        xl: PropTypes.bool,
      }).isRequired,
      getSelectedDateObject: PropTypes.func.isRequired,
      $rootScope: PropTypes.shape({}).isRequired,
      $location: PropTypes.shape({
        search: PropTypes.func.isRequired,
      }).isRequired,
      Analytics: PropTypes.shape({
        event: PropTypes.func.isRequired,
      }).isRequired,
      selectedCityCode: PropTypes.string.isRequired,
      selectorTagConfig: PropTypes.shape({
        party_size_change_event: PropTypes.string.isRequired,
        party_size_click_event: PropTypes.string.isRequired,
        time_change_event: PropTypes.string.isRequired,
        time_click_event: PropTypes.string.isRequired,
        open_calendar_event: PropTypes.string.isRequired,
        close_calendar_event: PropTypes.string.isRequired,
        date_selected_calendar_event: PropTypes.string.isRequired,
      }).isRequired,
      context: PropTypes.string.isRequired,
      displayText: PropTypes.string,
      selectorInfoSr: PropTypes.string.isRequired,
    }

  static defaultProps = {
    displayText: '',
  };

    state = {
      calendarOpen: false,

      selectedData: {
        seats: 2,
        date: '',
        time: '',
        modelDate: '',
      },
    }

    async componentDidMount() {
      const {
        $location,
      } = this.props;
      $location.search('seats', 2).replace();
      $location.search('date', this.currentDateInEST()).replace();

      await this.setState((prevState) => ({
        selectedData: {
          ...prevState.selectedData,
          date: this.currentDateInEST(),
          modelDate: this.currentDateModelInEST(),
        },
      }));
    }

    componentDidUpdate(prevProps, prevState) {
      const { selectedData } = this.state;
      const {
        $location,
      } = this.props;

      const {
        selectedData: {
          time: selectedTime,
          date: selectedDate,
          seats: selectedPartySize,
        }
        ,
      } = this.state;

      if (prevState.selectedData !== selectedData) {
        if (selectedTime === ALL_DAY) $location.search('time', null).replace();
        else $location.search('time', selectedTime).replace();
        $location.search('seats', selectedPartySize).replace();
        $location.search('date', selectedDate).replace();
      }
    }

    currentDateInEST = () => {
      moment.tz.setDefault('America/New_York');
      moment.tz.setDefault('America/New_York');
      const now = moment();
      const currentDateFullInEST = now.format('YYYY-MM-DD');
      return currentDateFullInEST;
    }

    currentDateModelInEST = () => {
      moment.tz.setDefault('America/New_York');
      const now = moment().toDate();
      return now;
    }

  handleDateSelect = async (selectedDate) => {
    const {
      Analytics, context: contextProps,
      selectorTagConfig:
      { date_selected_calendar_event: dateSelectedEvent },
    } = this.props;
    const selectedDateFormatted = moment(selectedDate).format('YYYY-MM-DD');

    await this.setState((prevState) => ({
      selectedData: {
        ...prevState.selectedData,
        date: selectedDateFormatted,
        modelDate: selectedDate,
      },
    }));

    const { selectedData } = this.state;

    this.toggleCalendar();
    const { getSelectedDateObject } = this.props;
    getSelectedDateObject(selectedData);
    await Analytics.event(dateSelectedEvent, {
      context: contextProps,
    });
  }

  toggleCalendar = async () => {
    const {
      Analytics, selectedCityCode, context: contextProps,
      selectorTagConfig:
      {
        open_calendar_event: openCalendarEvent,
        close_calendar_event: closeCalendarEvent,
      },
    } = this.props;
    const { calendarOpen } = this.state;
    const analyticsPayload = {
      city: selectedCityCode,
      context: contextProps,
    };

    if (calendarOpen) {
      await Analytics.event(closeCalendarEvent, analyticsPayload);
      document.body.classList.remove('prevent-scroll');
    } else {
      await Analytics.event(openCalendarEvent, analyticsPayload);
      document.body.classList.add('prevent-scroll');
    }

    this.setState({ calendarOpen: !calendarOpen });
  }

  onPartySizeChange = async ({ party_size: seats }) => {
    const {
      Analytics, context: contextProps,
      selectorTagConfig:
    {
      party_size_change_event: partySizeChangeEvent,
    },
    } = this.props;
    const { selectedData: { seats: selectedSeats } } = this.state;
    const previousQuantity = selectedSeats;
    if (!previousQuantity) return;
    if (String(previousQuantity) !== seats) {
      await Analytics.event(partySizeChangeEvent, {
        context: contextProps,
        'party size': seats,
      });
    }

    await this.setState((prevState) => ({
      selectedData: {
        ...prevState.selectedData,
        seats: Number(seats),
      },
    }));

    const { selectedData } = this.state;
    const { getSelectedDateObject } = this.props;
    getSelectedDateObject(selectedData);
  }

  onPartySizeClick = () => {
    const {
      Analytics, selectedCityCode, context: contextProps,
      selectorTagConfig:
    {
      party_size_click_event: partySizeClickEvent,
    },
    } = this.props;
    Analytics.event(partySizeClickEvent, {
      city: selectedCityCode,
      context: contextProps,
    });
  }

  onTimeClick = () => {
    const {
      Analytics, selectedCityCode, context: contextProps,
      selectorTagConfig:
  {
    time_click_event: timeClickEvent,
  },
    } = this.props;
    Analytics.event(timeClickEvent, {
      city: selectedCityCode,
      context: contextProps,
    });
  }

  onTimeChange = async ({ time }) => {
    const {
      Analytics, context: contextProps,
      selectorTagConfig:
    {
      time_change_event: timeChangeEvent,
    },
    } = this.props;

    const { selectedData: { time: selectedTime } } = this.state;
    if (time === null) return;
    const previousTime = time;
    if (!previousTime) return;
    if (String(previousTime) !== selectedTime && selectedTime !== '') {
      await Analytics.event(timeChangeEvent, {
        context: contextProps,
        time,
      });
    }
    await this.setState((prevState) => ({
      selectedData: {
        ...prevState.selectedData,
        time,
      },
    }));

    const { selectedData } = this.state;
    const { getSelectedDateObject } = this.props;
    getSelectedDateObject(selectedData);
  }

  render() {
    const {
      calendarOpen,
      selectedData: {
        time: selectedTime,
        date: selectedDate,
        modelDate: selectedModelDate,
        seats: selectedPartySize,
      }
      ,
    } = this.state;
    const {
      matchMedia,
      Analytics,
      displayText,
      selectorInfoSr,
    } = this.props;

    const dateLabel = moment(selectedDate).calendar();

    const { venueInventoryUtils } = utils;
    const todaysDate = moment();
    const inventoryByDay = venueInventoryUtils.getDateRange(todaysDate);
    const month = inventoryByDay ? moment(selectedModelDate) : moment();

    return (
      <div className="AmexShopSmallSelector__section">
        <p
          className="AmexShopSmallSelector__notification"
          tabIndex="-1"
        >
          {displayText}
        </p>
        <div role="group" aria-labelledby="sngSelectors">
          <span id="sngSelectors" className="sr-only">{selectorInfoSr}</span>
          <Selector
            date={dateLabel}
            isMobile={!matchMedia.md}
            onPartySizeChange={this.onPartySizeChange}
            onPartySizeClick={this.onPartySizeClick}
            onTimeChange={this.onTimeChange}
            onTimeClick={this.onTimeClick}
            showTimeFilter
            time={selectedTime}
            toggleCalendar={this.toggleCalendar}
            quantitySelected={selectedPartySize}
            calendarExpanded={calendarOpen}
          />
          {calendarOpen && (
          <div>
            <ResyCalendar
              Analytics={Analytics}
              className="ResyCalendar__Dropdown"
              clickableElementIdsToIgnore={['DateSelector__button']}
              numberOfMonths={1}
              getAriaLabel={venueInventoryUtils.getAriaLabel}
              calendarMap={inventoryByDay}
              closeCalendar={this.toggleCalendar}
              currentMonth={month}
              onClick={this.handleDateSelect}
              selectedDate={selectedDate}
              venueCity="Global Nav"
            />
          </div>
          )}
        </div>
      </div>
    );
  }
}

export default AmexShopSmallSelector;
